{
  "title": "Academy",
  "subtitle": "Sign young talent, develop it, and decide when to promote or sell.",
  "slotsU23": "U23 {used}/{max}",
  "slotsJunior": "Junior {used}/{max}",
  "balance": "Balance: {amount} CZ$",
  "disabledTitle": "Follow the academy on the roadmap",
  "disabledNote": "The academy is not open on your account yet.",
  "disabledAction": "See the roadmap",
  "graduationHeading": "Graduating riders",
  "intakeHeading": "Intake candidates",
  "rosterHeading": "Academy roster",
  "emptyIntake": "No intake candidates right now. New candidates arrive every Sunday.",
  "emptyAction": "Go to auctions",
  "emptyIntakeTitle": "Find a young rider in the auctions",
  "emptyRoster": "Young riders come up in the live auctions too, and signed candidates land here.",
  "emptyRosterTitle": "Sign your first academy rider",
  "youthSquads": {
    "title": "Youth squads",
    "roadmap": "Roadmap",
    "comingSoon": "Coming soon",
    "junior": {
      "title": "Junior team",
      "description": "Riders aged 18 or younger. Own races and standings."
    },
    "u23": {
      "title": "U23 team",
      "description": "Riders aged 22 or younger. Own races, divisions and promotion."
    }
  },
  "seriousBadge": "Serious prospect",
  "potential": "Potential",
  "potentialPending": "Not assessed yet",
  "ageLabel": "{age} y/o",
  "signBtn": "Sign",
  "rejectBtn": "Reject",
  "promoteBtn": "Promote",
  "sellBtn": "Sell",
  "youthSell": {
    "sell": "Sell",
    "edit": "Edit sale",
    "title": "Opens the rider page, where you set the price."
  },
  "releaseBtn": "Release",
  "graduationDeadline": "{days}d to decide",
  "graduationOverdue": "Overdue",
  "signingFee": "Signing fee",
  "expiryDays": "{days}d left",
  "expiryToday": "Expires today",
  "expiryTooltip": "Intake offers run for 7 days. Once an offer lapses the rider goes to a 24h youth auction, and you get the sale money if someone buys him.",
  "intakePull": {
    "title": "This week's intake",
    "description": "Your academy has a new group of candidates. You see age, nationality, type and current abilities. Potential is learned through training once they sign.",
    "deadlineNote": "Available until Saturday 23:59",
    "pullBtn": "Bring in this week's intake",
    "pulling": "Bringing them in...",
    "provisionalValue": "Provisional value",
    "wageOneSeason": "Wage (1 season)",
    "valuationNote": "Market value updated on Sunday. The potential forecast is learned through training and racing.",
    "abilitiesNow": "Abilities now",
    "emptyAfterPull": "No candidates left to review. Next week's intake opens Sunday.",
    "errorFailed": "Could not bring in this week's intake. Please try again."
  },
  "potentialLearned": "Learned through training and racing",
  "prognosis": {
    "learning": "Learning",
    "daysLeft": "{days} training/race days",
    "learningDays": "First read after {days} more training or race days.",
    "broad": "Rough read",
    "narrow": "Sharper read",
    "final": "Final read",
    "nextDays": "Sharper after {days} more training or race days.",
    "tooltip": "Recorded training and race days on your team narrow the forecast. Calendar days alone do not count. Better coaching and training facilities help you learn faster, without changing his talent.",
    "report": {
      "title": "Academy forecast",
      "progress": "Forecast stages",
      "forecast": "Forecast",
      "nextStage": "Next stage",
      "stages": {
        "learning": "Learning",
        "broad": "Rough",
        "narrow": "Sharper",
        "final": "Final"
      },
      "range": "{lo}–{hi} rating points",
      "noEstimate": "No estimate yet",
      "trainingDays": "{days, plural, one {# training or race day} other {# training or race days}}",
      "complete": "All stages reached",
      "unavailable": "Not known yet",
      "learningContext": "Recorded training and race days sharpen the forecast. Calendar days alone do not count.",
      "readMore": "Read more"
    }
  },
  "profile": {
    "heading": "Academy profile",
    "meta": "Level {tier} · {count} candidates a week",
    "locked": "Upgrade your academy facility to choose a profile for your intake.",
    "lockedAction": "Go to Club",
    "intro": "Each week's intake leans towards your profile, never fully. Potential is the same for every academy.",
    "origin": "Nationality or region",
    "type": "Rider type",
    "extra": "Extra choice",
    "extraLocked": "Unlocks at level 4",
    "typeLocked": "Unlocks at level 3",
    "none": "No preference",
    "groupNations": "Nations",
    "groupRegions": "Regions",
    "groupTypes": "Rider types",
    "save": "Save profile",
    "saved": "Saved. Your new profile takes effect {date}.",
    "active": "Active: {profile}",
    "activeNone": "No active profile yet.",
    "pending": "From {date}: {profile}",
    "delayNote": "Changes take effect after {days} days.",
    "errorSave": "Could not save the profile. Please try again.",
    "regions": {
      "nordic": "Nordic",
      "benelux": "Benelux",
      "iberia": "Iberia",
      "german_speaking": "German-speaking",
      "central_europe": "Central Europe",
      "english_speaking": "English-speaking",
      "latin_america": "Latin America",
      "east_asia": "East Asia",
      "africa": "Africa"
    }
  },
  "loading": "...",
  "fullTooltipU23": "Your U23 team is full ({max}/{max}). Free a place first.",
  "fullTooltipJunior": "Your junior team is full ({max}/{max}). Free a place first.",
  "fullNoteU23": "He joins your U23 team, and it is full. Sign once a place opens.",
  "fullNoteJunior": "He joins your junior team, and it is full. Sign once a place opens.",
  "contractUntil": "Until season {season}",
  "colNation": "Nation",
  "colRider": "Rider",
  "colType": "Type",
  "colAge": "Age",
  "colValue": "Value",
  "colSalary": "Salary",
  "colContract": "Contract",
  "colAction": "Action",
  "promoteSeniorFullTooltip": "Your senior squad is full. Free a senior place first.",
  "transferModal": {
    "promoteTitle": "Promote to senior squad",
    "promoteQuestion": "Promote this academy rider to your senior squad:",
    "promoteConfirm": "Promote",
    "promoteNote": "They take a senior place and a senior contract. Their youth wage is replaced by the senior wage shown above.",
    "promoteNoteKeepsContract": "They take a senior place. Their current contract and wage carry over unchanged.",
    "demoteNote": "They free a senior place and stop counting toward your senior squad. They are pulled from any upcoming races they were entered in.",
    "demoteNoteOngoing": "They free a senior place and stop counting toward your senior squad. They are pulled from any upcoming races they were entered in. Youth squad riders aren't race-eligible, so they will also drop out of the race currently underway shown above.",
    "demoteNoteKeepsContract": "They free a senior place and stop counting toward your senior squad. They are pulled from any upcoming races they were entered in. Their contract follows them down unchanged: same wage, same length.",
    "demoteNoteKeepsContractOngoing": "They free a senior place and stop counting toward your senior squad. They are pulled from any upcoming races they were entered in. Youth squad riders aren't race-eligible, so they will also drop out of the race currently underway shown above. Their contract follows them down unchanged: same wage, same length.",
    "seniorSalaryLabel": "Senior salary",
    "youthSalaryLabel": "Youth salary",
    "unchangedSalaryLabel": "Wage (unchanged)",
    "currentSalaryLabel": "Current salary",
    "seniorCapLabel": "Senior squad",
    "u23CapLabel": "U23 team places",
    "juniorCapLabel": "Junior team places",
    "racesClearedLabel": "Upcoming races cleared",
    "racesOngoingLabel": "Races they'll drop out of"
  },
  "moveSquad": {
    "title": "Move {name}",
    "fallbackRider": "this rider",
    "nowOn": "Now on the <strong>{squad}</strong>.",
    "nowOnWithAge": "Now on the <strong>{squad}</strong> · season age {age}.",
    "pick": "Pick the new squad:",
    "pickerLabel": "New squad",
    "rowName": { "senior": "Senior squad", "u23": "U23 team", "junior": "Junior team" },
    "shortName": { "senior": "Senior", "u23": "U23", "junior": "Junior" },
    "hint": {
      "current": "Current squad",
      "tooOld": "Too old for {squad} (max {max})",
      "full": "{squad} is full ({max}). Free a place there first.",
      "seniorPlace": "Takes a senior place",
      "natural": "Natural squad at age {age}",
      "naturalNoAge": "Natural squad for this age",
      "upward": "Allowed: upward move"
    },
    "confirm": { "senior": "Move to senior squad", "u23": "Move to U23", "junior": "Move to Junior" },
    "confirmNone": "Move",
    "moveNote": "Only the squad changes. Wage and contract stay exactly as they are.",
    "errors": {
      "same_squad": "The rider is already in that squad.",
      "too_old_for_squad": "The rider is too old for the {short} squad.",
      "squad_full": "{squad} is full ({max}). Free a place there first.",
      "rider_on_market": "The rider is in an active auction. End it before moving the rider.",
      "rider_listed": "The rider is on the transfer list. Remove the listing before moving the rider.",
      "rider_in_stage_race": "The rider is in the middle of a stage race. Try again when it's over.",
      "academy_disabled": "Moving riders between squads isn't available right now.",
      "network": "Couldn't reach the server. Try again.",
      "failed": "Couldn't move the rider. Try again."
    }
  },
  "error": {
    "academyFull": "Academy is full. Cannot sign another rider.",
    "notOffered": "This rider has not been offered a place.",
    "insufficientBalance": "You cannot afford the signing fee.",
    "insufficientAvailableBalance": "Not enough available money: part of your balance is locked in auction bids.",
    "alreadyAssigned": "This rider has already joined an academy.",
    "riderOwned": "This rider is currently on another team, so the offer cannot be completed right now. I'm working on it, and your offer stays open.",
    "squadFull": "Senior squad is full. Free a spot to promote, or sell or release instead.",
    "riderOnAuction": "This rider is on an active auction and can't be released until it ends.",
    "cannotAffordRelease": "You can't afford the buyout fee for this rider.",
    "riderStateChanged": "This rider is no longer in your academy.",
    "generic": "Something went wrong. Please try again.",
    "loadTitle": "Could not load your academy",
    "loadBody": "The academy data did not come through. Reload the page, and let me know if it keeps happening."
  },
  "releaseModal": {
    "title": "Release academy rider",
    "question": "End this academy rider's contract:",
    "feeLabel": "Buyout fee",
    "balanceLabel": "Your balance",
    "feeHint": "The buyout fee is half the salary left on the contract, same as for senior riders.",
    "freeHint": "This rider is out of contract, so there's no buyout fee.",
    "cannotAfford": "You can't afford the buyout fee.",
    "confirm": "Release rider"
  },
  "pnl": {
    "heading": "Academy accounts",
    "subtitle": "Only realized sales count. Riders still in your academy show no value here until sold.",
    "loadingNote": "Loading academy accounts...",
    "cumulativeHeading": "All-time cash flow",
    "driftPaid": "Upkeep paid",
    "signingFeesPaid": "Signing fees paid",
    "salesProceeds": "Sale proceeds",
    "valueCreation": "Sale premium",
    "netCashFlow": "Net cash flow",
    "premiumCaption": "Sale premium is the amount received above each rider's market value at the moment they were listed for sale.",
    "currentHeading": "Current squad",
    "slotsLabel": "Places used",
    "payrollLabel": "Current payroll (per season)",
    "currentCaption": "A snapshot of today's academy, not part of the cash flow totals on the left.",
    "salesHeading": "Recent academy sales",
    "emptySales": "No academy graduates sold yet.",
    "colRider": "Rider",
    "colDate": "Date",
    "colPrice": "Sale price",
    "colPremium": "Premium",
    "unknownRider": "Former academy rider"
  },
  "graduationBanner": {
    "title": "{count, plural, one {1 rider has outgrown his squad} other {# riders have outgrown their squad}}",
    "body": "Decide before the season turns, or the club picks for you.",
    "action": "Open Graduation Day"
  },
  "graduationDay": {
    "title": "Graduation Day",
    "subtitleDays": "{count, plural, one {1 rider has outgrown his squad} other {# riders have outgrown their squad}}. {days, plural, one {1 day} other {# days}} to decide.",
    "subtitleDue": "{count, plural, one {1 rider has outgrown his squad} other {# riders have outgrown their squad}}. The deadline has passed.",
    "subtitlePlain": "{count, plural, one {1 rider has outgrown his squad} other {# riders have outgrown their squad}}.",
    "confirmAll": "Confirm all",
    "riderCount": "{count, plural, one {1 rider} other {# riders}}",
    "backToAcademy": "Back to Academy",
    "emptySubtitle": "Nobody is moving between squads right now.",
    "emptyTitle": "No riders are graduating",
    "emptyBody": "The next Graduation Day opens the week before the season turns.",
    "defaultNote": "If you do nothing, riders move up when there is room, otherwise they are listed for sale.",
    "someFailed": "Some riders could not be moved. See the reason on each row, then try again.",
    "contractUntil": "Until season {season}",
    "contractNone": "No contract",
    "colRider": "Rider",
    "colRating": "Rating",
    "colPotential": "Potential",
    "colContract": "Contract",
    "colCoach": "Coach",
    "colChoice": "Choice",
    "choiceLabel": "Choice for {name}",
    "squad": {
      "junior": "Junior team",
      "u23": "U23 team",
      "senior": "Senior team",
      "unknown": "Academy"
    },
    "transition": {
      "junior_u23": "From Junior team to U23 team",
      "u23_senior": "From U23 team to Senior team",
      "unknown_senior": "To Senior team",
      "fallback": "From {from} to {to}"
    },
    "choice": {
      "promote": "Move up",
      "sell": "Sell",
      "release": "Release"
    },
    "blocked": {
      "squadFull": "Squad is full ({count}/{max})"
    },
    "coach": {
      "unknown": "I have not seen enough of him to say where he lands.",
      "unproven": "I have a feel for him, but not a firm one yet.",
      "climbing": "There is still a good stretch of road ahead of him.",
      "arriving": "He is close to the rider I expect him to be.",
      "settled": "He has grown into the rider I thought he would be."
    },
    "rowError": {
      "not_pending": "His window has already closed. Reload the page.",
      "squad_cap_violation": "No room in the squad he was moving to.",
      "rider_not_found": "This rider is no longer in your academy.",
      "failed": "That did not go through. Try again."
    }
  },
  "boardGift": {
    "heading": "A thank-you from the board",
    "meta": "{count} open",
    "context": "The board has put these prospects in your academy as a thank-you. Signing is free, normal youth wages apply, and squad limits still count. The offers run for 14 days, and the ones you do not pick leave quietly.",
    "free": "Free"
  }
}
